import React, { FC } from "react";

import CloseButton from "./closeButton";
import ScanSwitch from "./scanSwitch";
import CameraButton from "../assets/camera_button_dark.png";

import { useGlobalContext } from "./ScanViewerContext";

import styles from "./cardCapture.module.scss";

type Props = {
  children: React.ReactNode;
};

const CardCapture: FC<Props> = ({ children }) => {
  const {
    showCurtain,
    onCloseBtn,
    closeButton,
    isMobileOnLandscape,
    stateMachineState,
    stateMachineSend,
    isMobile,
  } = useGlobalContext();

  const isPending = ["cameraLoading", "autoCapture", "manualCapture"].some(
    stateMachineState.matches
  );

  return (
    <>
      {!showCurtain && (
        <CloseButton onCloseBtn={onCloseBtn} closeButton={closeButton} />
      )}
      <div
        className={`${styles.topCurtain} ${
          isMobileOnLandscape && styles.topCurtainLandscape
        }`}
        style={{
          display: showCurtain ? "block" : "none",
        }}
        id="mobileTopCurtain"
      >
        {showCurtain && (
          <CloseButton onCloseBtn={onCloseBtn} closeButton={closeButton} />
        )}
        {showCurtain && !stateMachineState.context.processing && (
          <ScanSwitch isMobile={showCurtain} />
        )}
      </div>
      {children}
      <div
        id="mobileBottomCurtain"
        className={
          isMobileOnLandscape
            ? styles.bottomCurtainLandscape
            : styles.bottomCurtain
        }
        style={{
          display: showCurtain ? "block" : "none",
        }}
      >
        {!stateMachineState.context.autoScan &&
          !stateMachineState.context.processing && (
            <img
              data-cy="cameraBtn"
              alt="button to start the scanning"
              src={CameraButton}
              className={`${styles.cameraBtn} ${isMobile ? styles.mobile : ""}`}
              id="camera-btn"
              onClick={() => stateMachineSend("MANUAL_BUTTON_CLICK")}
            />
          )}
      </div>
    </>
  );
};

export default CardCapture;
